// extracted by mini-css-extract-plugin
module.exports = {"Host":"Home_Host_3I3tS","TaskList":"Home_TaskList_1EnYj","Footer":"Home_Footer_2uGA4","AddNew":"Home_AddNew_qQ5bm","Spacer":"Home_Spacer_138GW"};